import React from "react";
import { Outlet } from "react-router-dom";

import "./App.css";

import { useGetVehiclesQuery } from "./api/wordpress";
import { BookingProvider } from "./providers/BookingProvider";
import { VehicleSelectionProvider } from "./providers/VehicleSelectionProvider";

const Root: React.FC = () => {
  const { isLoading } = useGetVehiclesQuery();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="relative w-32 h-32">
          <div className="absolute w-full h-full border-4 border-gray-200 rounded-full"></div>
          <div className="absolute w-full h-full border-4 border-t-blue-500 rounded-full animate-spin"></div>
        </div>
      </div>
    );
  }

  return (
    <>
      <BookingProvider>
        <VehicleSelectionProvider>
          <Outlet />
        </VehicleSelectionProvider>
      </BookingProvider>
    </>
  );
};

export default Root;
